<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="超融合三合一：Blueiaas-LX5-HS101" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="22" :sm="22" :md="22" :lg="22" :xl="18" :xxl="18">
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-film-outline"></Icon>
                  产品简介： LX5-HS101
                </Title>
              </template>
              <div style="display: flex; flex-direction:row; justify-content:space-between;">
                <Typography>
                  <Paragraph>
                    <Title :level="6">轻量高效，可靠稳定，低代价轻松上云，快捷享受云端的虚拟化和自动快照特性</Title>
                  </Paragraph>
                  <Paragraph>
                    <ul>
                        <li>承载非计算型的企业应用，核心数相对较多</li>
                        <li>支持16C-32G-500G/16C-32G-500G/4C-16G-700G三台云主机（128GB内存版本，￥{{ Price['LX5-HS101'][0] }}）</li>
                        <li>支持16C-96G-500G/16C-64G-500G/4C-16G-700G三台云主机（256GB内存版本，￥{{ Price['LX5-HS101'][1] }}）</li>
                        <li>支持10个自动快照，每天自动生成，提供最近10天的数据回滚能力，可有效对抗勒索病毒等常见数据风险。</li>
                    </ul>
                  </Paragraph>
                  <Paragraph>
                    <Title :level="6">典型应用场景</Title>
                    <Text>处在初步信息化阶段的中小企业，或者用于在大型IT结构中运行非核心部分的业务。一体机的形式，x86的处理器架构，适应当前最广泛的企业应用架构，自带虚拟化，提升服务器的利用率的同时还能带来更多的数据安全能力。</Text>
                  </Paragraph>
                </Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
              </div>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-list" />
                  技术参数
                </Title>
              </template>
              <Table :columns="columns" :data="data"></Table>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-medal-outline" />
                  产品优势
                </Title>
              </template>
              <Typography>
                <Paragraph>
                  <Text>开箱即包含三个已经完成配置的云主机，并附带10天的自动快照，支持1+1+1部署，一个云主机承载应用服务器，一个云主机承载数据库服务器，一个云主机承载维护跳板机和数据备份的服务器，在一个物理服务器上即可实现简单的存算分离架构和应用层的数据备份，降低整体运维的难度，大幅度的提升数据的可靠性。</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="0" :sm="0" :md="0" :lg="0" :xl="6" :xxl="6">
            <BlueiaasSideList></BlueiaasSideList>
          </Col>
      </Row>
    </div>
</template>

<script>
import BlueiaasSideList from '@/components/Blueiaas-sideList.vue'
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
import RPrice from '@/http/Price.js'
export default {
  name: 'Blueiaas-LX5-HS101',
  components: {
    BlueiaasSideList,
    Header,
    HeaderSec
  },
  setup() {
  },
  data(){
    return {
        BreadcrumbList: [
            {
                title: '首页',
                to: '/'
            },
            {
                title: '云与基础设施',
                to: '/Blueiaas'
            },
            {
                title: 'Blueiaas-LX5-HS101'
            }
        ],
        Price: {
          /** 256GB, 512GB */
          "LX5-HL101": [ 0, 0],
          "LX5-HS101": [ 0, 0],
          "LX5-HP101": [ 0, 0],
          "LX5-HL302": [ 0, 0],
          "LX5-HS302": [ 0, 0],
          "LX5-HP302": [ 0, 0],
          "LX5-HL303": [ 0, 0],
          "LX5-HS303": [ 0, 0],
          "LX5-HP303": [ 0, 0],
          "LX5-ML021": [0, 0],
          "LX5-ML022": [0, 0],
          "LX5-ML023": [0, 0],
          "LX5-MP022": [0, 0],
        },
        columns: [
            {
                title: '技术项',
                key: 'key',
            },
            {
                title: '参数',
                key: 'value'
            },
        ],
        data: [
            {
              key:"型号",
              value:"LX5-HS101",
            },
            {
              key:"机型",
              value:"2U标准机架设备，8盘位热插拔（C62128F）",
            },
            {
              key:"处理器",
              value:"Intel® 至强 金牌6138 2.0GHz 20C * 2",
            },
            {
              key:"内存",
              value:"128GB/256GB",
            },
            {
              key:"存储",
              value:"固态硬盘 3.84TB SSD * 3（raid5）",
            },
            {
              key:"RAID控制器",
              value:"LSI 9361-8I,1G缓存，支持raid 0.1.5.10.50.60",
            },
            {
              key:"网络接口",
              value:"1Gbps网线接口 * 2； IPMI网线接口 * 1",
            },
            {
              key:"电源",
              value:"800W 1+1 冗余电源",
            },
            {
              key:"导轨",
              value:"静态导轨, 适用于2/4柱式机架",
            },
            {
              key:"外型尺寸",
              value:"43x437x724mm(WHD)",
            },
            {
              key:"工作环境",
              value:"10~35C(50~95F)，10%~90%，存储环境：-10~60C，10%~90%（非冷凝）",
            },
            {
              key:"系统支持",
              value:"Windows，Redhat linux， centos， ubuntu",
            },
        ],
    }
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  },
  mounted () {
    this.Price = RPrice.getPrice();
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 90%;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
}
</style>
